import { ElementRef, forwardRef, OnChanges, OnInit } from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';
var INPUT_FIELD_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return SelectWithSearchComponent; }),
    multi: true,
};
var SelectWithSearchComponent = /** @class */ (function () {
    function SelectWithSearchComponent() {
        var _this = this;
        this.items = [];
        this.floatLabel = null;
        this.searchLabel = null;
        this.noItemsFoundMessage = null;
        this.errorMessageRequired = null;
        this.archivedLabel = null;
        this.fxFlex = 100;
        this.disableOptionIf = null;
        this.isMultiple = false;
        this.disabled = false;
        this.required = false;
        this.underlineArchivedItems = false;
        this.returnValueInObject = false;
        this.appearance = 'legacy';
        this.selectedValue = new FormControl();
        this.searchValue = new FormControl();
        this.filteredItemsIds = [];
        this.onChange = function () { };
        this.onTouched = function () { };
        this.selectedValue.valueChanges.pipe(debounceTime(100)).subscribe(function (value) {
            if (value) {
                _this.onChange(value);
            }
        });
    }
    SelectWithSearchComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.filteredItemsIds = this.items.map(function (item) { return item.id; });
        if (this.required) {
            this.selectedValue.setValidators(Validators.required);
        }
        this.searchValue.valueChanges.subscribe(function (value) {
            if (!value) {
                _this.filteredItemsIds = _this.items.map(function (item) { return item.id; });
                return;
            }
            _this.filteredItemsIds = _this.items.filter(function (item) {
                var itemField = item[_this.fieldDisplayedInMatOption].toLowerCase();
                return itemField.includes(value.toLowerCase());
            }).map(function (item) { return item.id; });
        });
    };
    SelectWithSearchComponent.prototype.ngOnChanges = function () {
        this.filteredItemsIds = this.items.map(function (item) { return item.id; });
    };
    SelectWithSearchComponent.prototype.searchInputFocus = function (toClean) {
        if (toClean === void 0) { toClean = false; }
        if (toClean) {
            this.searchValue.setValue(null);
        }
        this.searchInput.nativeElement.focus();
    };
    SelectWithSearchComponent.prototype.writeValue = function (itemOrItems) {
        this.selectedValue.setValue(itemOrItems);
    };
    SelectWithSearchComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    SelectWithSearchComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    SelectWithSearchComponent.prototype.compareItems = function (firstItem, secondItem) {
        if (firstItem === secondItem) {
            return true;
        }
        if (!firstItem || !secondItem || typeof firstItem !== 'object' || typeof secondItem !== 'object') {
            return false;
        }
        return firstItem.id === secondItem.id;
    };
    return SelectWithSearchComponent;
}());
export { SelectWithSearchComponent };
